const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryinstructionDetail({ rootState }, params = {}) {
      const data = await rootState.http("/tutorial/findTutorial", params);
      return data;
    }
  }
};

export default store;
